import React from "react";
import { Tooltip as AntdTooltip } from "antd";

const Tooltip = (props) => {
  return <AntdTooltip {...props} />;
};

export default Tooltip;
